import iconClose from '../img/icons/icon-close.svg';
import PropTypes from 'prop-types';
import React from 'react';


export const SEARCH_BUSY_MIN_MS = 400;


export function SearchBusyIndicator(){
  return (
    <span className="button-input__busy"
          role="status"
          aria-live="polite">
      <span className="button-input__busy-spinner" aria-hidden="true"/>
      <span className="visually-hidden">Loading search results</span>
    </span>
  );
}


export default function SearchClearOrBusy({isLoading, onClear, iconSrc, alt = ''}){
  if(isLoading){
    return <SearchBusyIndicator/>;
  }

  return (
    <button aria-label="Clear"
            className="button-input__button button-input__button--clear"
            type="button"
            onMouseDown={e => e.preventDefault()}
            onClick={onClear}>
      <img alt={alt} className="button-input__button-icon" src={iconSrc || iconClose}/>
    </button>
  );
}


SearchClearOrBusy.propTypes = {
  alt: PropTypes.string,
  iconSrc: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isLoading: PropTypes.bool,
  onClear: PropTypes.func,
};
